import { Dispatch, SetStateAction } from "react";
import { Action } from "redux";
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";
import { getToken } from "./token_fetcher";
import { Job } from "../../shared/queue";
import { DataDownloadFlowJobData, DataDownloadFlowProgress } from "../../model";

export const REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_CANCEL =
  "REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_CANCEL";
export const doREQUEST_PROJECT_DATA_DOWNLOAD_FLOW_CANCEL = createDoRequestAction(
  REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_CANCEL,
);

export const requestProjectDataDownloadFlowCancelActionCreators = {
  doREQUEST_PROJECT_DATA_DOWNLOAD_FLOW_CANCEL,
};

export interface RequestProjectDataDownloadFlowCancelPayload extends Action {
  payload: {
    requestId: string;
    projectId: string;
  };
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>;
}

export interface ProjectDataDownloadFlowCancelResponsePayload {
  payload: {
    job: Job<DataDownloadFlowJobData, DataDownloadFlowProgress> | null;
  };
}

export function* requestProjectDataDownloadFlowCancel({
  payload,
  setRequestResult,
}: RequestProjectDataDownloadFlowCancelPayload): SagaIterator {
  debug("saga*requestProjectDataDownloadFlowCancel");
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_CANCEL,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { projectId } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/project-data-download-flow-cancel`,
    accessToken,
    data: {
      projectId,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_CANCEL,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/project-data-download-flow-cancel",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_CANCEL,
        fromPayload: payload,
        requestId: payload.requestId,
        url: "/v1/web/project-data-download-flow-cancel",
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* ProjectDataDownloadFlowCancelSaga() {
  yield takeEvery(REQUEST_PROJECT_DATA_DOWNLOAD_FLOW_CANCEL, requestProjectDataDownloadFlowCancel);
}
